module.exports = __webpack_public_path__ + "static/media/LY.0f54fcea.png";